import { Loading, ModalCustom } from './index.style';

const ModalLoading = (open: any) => {
  return (
    <ModalCustom open={open.open} centered footer={false}>
      <div style={{ textAlign: 'center' }}>
        <Loading>
          <div className='one'></div>
          <div className='two'></div>
          <div className='three'></div>
          <div className='four'></div>
          <div className='five'></div>
        </Loading>
      </div>
    </ModalCustom>
  );
};
export default ModalLoading;
